import { UserInfo } from '../types';
import apiRequest from './apiRequest';

export default async function putUserProducts(
  targetUserID: string,
  props: {
    spinsToAdd?: number;
    premiumAccessUntil?: string,
  }
) {
  return await apiRequest<{ userInfo: UserInfo }>(
    'user',
    `/users/products/${targetUserID}`,
    {
      method: 'PUT',
      body: JSON.stringify(props),
    },
  );
}
